<template>
  <div>
    <section>
      <div class="bg-pattern overlay-ltdcReg logReg-container">
        <div class="lc-wizard-col mx-auto">
          <!--limited company wizard block start-->
          <div class="lc-heading">Limited company</div>
          <div class="lc-wizard">
            <div class="lc-card">
              <LimitedCompanyForm></LimitedCompanyForm>
            </div>
          </div>
          <!--ended limited company wizard block-->
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import LimitedCompanyForm from './LimitedCompanyForm.vue';

export default {
  name: "LimitedCompany",

  components: {
    LimitedCompanyForm
  },
  data() {
    return {
      loadingInstance: null,
      loading: false,
    };
  },
  created() {

  },
  computed: {

  },
  methods: {
  },
};
</script>
<style scoped>
.lc-wizard-col {
  width: 637px;
  max-width: 100%;
  position: relative;
  z-index: 1;
}

.lc-wizard {
  width: 100%;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

/* Title above the popup */
.lc-heading {
  background: #008490;
  height: 55px;
  width: 210px;
  margin: 0;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px 8px 0 0;
}

/* Card body */
.lc-card {
  background: #fbfbfc;
  padding: 34px 74px 40px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

@media (max-width: 520px) {
  .lc-card {
    padding: 26px 20px 32px;
  }
}
</style>
